<div class="page-layout">
  <app-sidebar></app-sidebar>

  <main class="main-content">
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">&rsaquo;</span>
      <span class="breadcrumb-item active">Sports</span>
    </nav>

    <header class="page-header">
      <h1 class="page-title">Sports Management</h1>
      <button class="btn btn-primary" (click)="openAddModal()">
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        Add Sport
      </button>
    </header>

    <!-- Alerts -->
    <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
    <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

    <!-- Loading -->
    <div class="loading-container" *ngIf="isLoading">
      <p>Loading sports...</p>
    </div>

    <!-- Sports Grid -->
    <div class="sports-grid" *ngIf="!isLoading" cdkDropList (cdkDropListDropped)="onDrop($event)">
      <div class="sport-card" *ngFor="let sport of sports" [class.inactive]="!sport.isActive" cdkDrag>
        <div class="drag-handle" cdkDragHandle>
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path fill="currentColor" d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
        </div>
        <!-- Image -->
        <div class="sport-image-container">
          <img
            *ngIf="sport.imageUrl"
            [src]="getImageUrl(sport)"
            [alt]="sport.name"
            class="sport-image"
          />
          <div class="sport-image-placeholder" *ngIf="!sport.imageUrl">
            <svg viewBox="0 0 24 24" width="48" height="48">
              <path fill="#ccc" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
            </svg>
            <span>No image</span>
          </div>
          <!-- Upload overlay -->
          <label class="upload-overlay" [class.uploading]="uploadingSportId === sport.id">
            <input
              type="file"
              accept="image/png,image/jpeg,image/jpg"
              (change)="onFileSelected($event, sport)"
              [disabled]="uploadingSportId === sport.id"
              hidden
            />
            <span *ngIf="uploadingSportId !== sport.id">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/>
              </svg>
              Upload Image
            </span>
            <span *ngIf="uploadingSportId === sport.id">Uploading...</span>
          </label>
        </div>

        <!-- Gallery Images -->
        <div class="gallery-section">
          <div class="gallery-header">
            <span class="gallery-title">Gallery Images</span>
          </div>
          <div class="gallery-thumbnails" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onGalleryDrop($event, sport)">
            <div class="gallery-thumb" *ngFor="let image of sport.galleryImages" cdkDrag>
              <img [src]="getGalleryImageUrl(image)" [alt]="sport.name" />
              <button class="gallery-thumb-delete" (click)="deleteGalleryImage(sport, image)" title="Delete">&times;</button>
            </div>
            <label class="gallery-add-btn" [class.uploading]="uploadingGallerySportId === sport.id">
              <input
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                (change)="onGalleryFileSelected($event, sport)"
                [disabled]="uploadingGallerySportId === sport.id"
                hidden
              />
              <span *ngIf="uploadingGallerySportId !== sport.id">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
              </span>
              <span *ngIf="uploadingGallerySportId === sport.id">...</span>
            </label>
          </div>
        </div>

        <!-- Info -->
        <div class="sport-info">
          <h3 class="sport-name">{{ sport.name }}</h3>

          <!-- Description (inline editable) -->
          <div class="description-section" *ngIf="editingDescriptionId !== sport.id">
            <p class="sport-description" *ngIf="sport.description">{{ sport.description }}</p>
            <button class="description-edit-btn" (click)="startEditDescription(sport)" title="Edit description">
              <svg viewBox="0 0 24 24" width="14" height="14">
                <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
              {{ sport.description ? 'Edit' : 'Add description' }}
            </button>
          </div>
          <div class="description-edit" *ngIf="editingDescriptionId === sport.id">
            <textarea
              class="form-input"
              [(ngModel)]="editDescriptionValue"
              placeholder="Sport description"
              rows="3"
            ></textarea>
            <div class="description-edit-actions">
              <button class="btn btn-secondary btn-sm" (click)="cancelEditDescription()">Cancel</button>
              <button class="btn btn-primary btn-sm" (click)="saveDescription(sport)">Save</button>
            </div>
          </div>

          <!-- Toggles -->
          <div class="sport-toggles">
            <div class="toggle-row">
              <span class="toggle-label">Active</span>
              <label class="toggle-switch">
                <input type="checkbox" [checked]="sport.isActive" (change)="toggleActive(sport)" />
                <span class="toggle-slider"></span>
              </label>
            </div>
            <div class="toggle-row">
              <span class="toggle-label">Coming Soon</span>
              <label class="toggle-switch">
                <input type="checkbox" [checked]="sport.isComingSoon" (change)="toggleComingSoon(sport)" />
                <span class="toggle-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Sport Modal -->
    <div class="modal-backdrop" *ngIf="showAddModal" (click)="closeAddModal()">
      <div class="modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2 class="modal-title">Add Sport</h2>
          <button class="modal-close" (click)="closeAddModal()">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Name *</label>
            <input
              type="text"
              class="form-input"
              [(ngModel)]="newSportName"
              placeholder="e.g. Basketball"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Description</label>
            <textarea
              class="form-input"
              [(ngModel)]="newSportDescription"
              placeholder="Optional description"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeAddModal()" [disabled]="isCreating">Cancel</button>
          <button class="btn btn-primary" (click)="createSport()" [disabled]="isCreating">
            {{ isCreating ? 'Creating...' : 'Create Sport' }}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>
